import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Upload, Button, message } from "antd";
import axios from "axios";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;
const { Option } = Select;

const UpdateFileModal = ({ visible, onCancel, document, currentFolder, allFolders, apiUrl }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();

  const handleEditDocument = async values => {
    try {
      await axios.put(`${apiUrl}/documents/update/${document?._id}`, values, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      message.success(t("Document updated successfully"));
      onCancel();
      form.resetFields();
    } catch (error) {
      console.error("Update error:", error);
      message.error(t("Failed to update document"));
    }
  };

  useEffect(() => {
    form.setFieldsValue(document);

    return () => {};
  }, [document]);

  return (
    <Modal
      title={t("Edit Document")}
      open={visible}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      width={600}
      footer={
        <>
          <Button
            onClick={() => {
              onCancel();
              form.resetFields();
            }}
          >
            {t("Cancel")}
          </Button>
          <Button type="primary" onClick={() => form.submit()}>
            {t("Save Changes")}
          </Button>
        </>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleEditDocument}>
        <Form.Item
          name="name"
          label={t("Document Name")}
          rules={[{ required: true, message: t("Please enter document name") }]}
        >
          <Input placeholder={t("Enter document name")} />
        </Form.Item>

        <Form.Item name="description" label={t("Description")}>
          <TextArea rows={3} placeholder={t("Enter document description")} />
        </Form.Item>

        <Form.Item name="folderId" label={t("Folder")}>
          <Select placeholder={t("Select folder")} allowClear>
            {allFolders.map(folder => (
              <Option key={folder._id} value={folder._id}>
                {folder.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateFileModal;
